// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-department {
    width: 250px; /* Adjust width */
    height: 320px; /* Adjust height */
    text-align: center;
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly; /* Space content vertically */
    align-items: flex-start;
    overflow: hidden; /* Prevents content from overflowing */
}

.employee-department h3{
    margin-top: 0;
}

.employee-department-title {
    margin-top: 15px;
}



.employee-department-chart {box-sizing: border-box;
    display: block;
    height: 300px;
    width: 300px;
}

.employee-department-session {
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
}

.employee-department-legend {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 18px;
    flex-wrap: wrap;
}

.employee-department-legend-item {
    display: flex;
    align-items: center;
    font-size: 10px;
}

.employee-department-legend-color {
    width: 12px;
    height: 12px;
    border-radius: 0%;
    display: inline-block;
    margin-right: 5px;
}
.chart-container-bydepartment {
    width: 100%;
    
    height: 100%;
    margin: auto;
    padding: 10px;
    
  }`, "",{"version":3,"sources":["webpack://./src/components/MyDashboard/EmployeeByDepartment.css"],"names":[],"mappings":"AAAA;IACI,YAAY,EAAE,iBAAiB;IAC/B,aAAa,EAAE,kBAAkB;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,6BAA6B,EAAE,6BAA6B;IAC5D,uBAAuB;IACvB,gBAAgB,EAAE,sCAAsC;AAC5D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA,4BAA4B,sBAAsB;IAC9C,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,WAAW;;IAEX,YAAY;IACZ,YAAY;IACZ,aAAa;;EAEf","sourcesContent":[".employee-department {\n    width: 250px; /* Adjust width */\n    height: 320px; /* Adjust height */\n    text-align: center;\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly; /* Space content vertically */\n    align-items: flex-start;\n    overflow: hidden; /* Prevents content from overflowing */\n}\n\n.employee-department h3{\n    margin-top: 0;\n}\n\n.employee-department-title {\n    margin-top: 15px;\n}\n\n\n\n.employee-department-chart {box-sizing: border-box;\n    display: block;\n    height: 300px;\n    width: 300px;\n}\n\n.employee-department-session {\n    font-size: 18px;\n    font-weight: bold;\n    margin-top: 10px;\n}\n\n.employee-department-legend {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 18px;\n    flex-wrap: wrap;\n}\n\n.employee-department-legend-item {\n    display: flex;\n    align-items: center;\n    font-size: 10px;\n}\n\n.employee-department-legend-color {\n    width: 12px;\n    height: 12px;\n    border-radius: 0%;\n    display: inline-block;\n    margin-right: 5px;\n}\n.chart-container-bydepartment {\n    width: 100%;\n    \n    height: 100%;\n    margin: auto;\n    padding: 10px;\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
